import React from 'react';
import { CheckCircle2, Lock } from 'lucide-react';
import { Panel } from '../../common/Panel';
import { StatusBadge } from '../../common/StatusBadge';
import { toBn } from '../../../utils/bn';
import type { CheckResult } from '../../../types/review';
interface Props {
  title: string;
  items: string[];
  checks: boolean[];
  result?: CheckResult;
  disabled?: boolean;
  onChange: (checks: boolean[]) => void;
  onResult: (r: CheckResult) => void;
}
const results: {
  key: CheckResult;
  cls: string;
  on: string;
}[] = [{
  key: 'যাচাইকৃত',
  cls: 'border-emerald-200 text-emerald-800 hover:bg-emerald-50',
  on: 'border-emerald-600 bg-emerald-600 text-white'
}, {
  key: 'তথ্যের অমিল',
  cls: 'border-red-200 text-red-700 hover:bg-red-50',
  on: 'border-red-600 bg-red-600 text-white'
}, {
  key: 'সংশোধন প্রয়োজন',
  cls: 'border-amber-200 text-amber-800 hover:bg-amber-50',
  on: 'border-amber-500 bg-amber-500 text-white'
}];
export function ReviewChecklistPanel({
  title,
  items,
  checks,
  result,
  disabled,
  onChange,
  onResult
}: Props) {
  const done = checks.filter(Boolean).length;
  const all = done === items.length;
  return <Panel title={title} subtitle={`${toBn(done)}/${toBn(items.length)} বিষয় যাচাই সম্পন্ন`} actions={result ? <StatusBadge tone={result === 'যাচাইকৃত' ? 'green' : result === 'তথ্যের অমিল' ? 'red' : 'orange'} data-id="element-533" data-mp="2giujg9oah8t4">{result}</StatusBadge> : <StatusBadge tone="gray" data-id="element-534" data-mp="2qexkfc7en1eh">যাচাই অপেক্ষমাণ</StatusBadge>} data-id="element-532" data-mp="22qo1qj5hmtrk">
      {disabled && <p className="mb-3 flex items-center gap-1.5 rounded-md bg-slate-100 px-3 py-2 text-xs text-slate-600" data-id="element-535" data-mp="2qh1y2lv3very"><Lock className="h-3.5 w-3.5" data-id="element-536" data-mp="2li76auf5ufvp" />আপনার বর্তমান ভূমিকায় এই যাচাই সম্পাদনার অনুমতি নেই (কেবল দেখা যাবে)।</p>}
      <ul className="space-y-1.5" data-id="element-537" data-mp="2ugj4bhicwfy6">
        {items.map((label, i) => <li key={label} data-id="element-538" data-mp="2uhc767e72lb1" data-mpi={i}>
            <label className={`flex items-center gap-2.5 rounded-md border px-3 py-2 text-sm ${checks[i] ? 'border-emerald-200 bg-emerald-50/60' : 'border-slate-200'} ${disabled ? 'cursor-not-allowed opacity-80' : 'cursor-pointer'}`} data-id="element-539" data-mp="151mi5x8xw8t6">
              <input type="checkbox" className="h-4 w-4 accent-emerald-600" checked={Boolean(checks[i])} disabled={disabled} onChange={() => onChange(items.map((_, n) => n === i ? !checks[n] : Boolean(checks[n])))} data-id="element-540" data-mp="305st8wi56w2g" />
              <span className="flex-1 text-navy-900" data-id="element-541" data-mp="3e5bt720sv13o">{label}</span>
              {checks[i] && <CheckCircle2 className="h-4 w-4 text-emerald-600" data-id="element-542" data-mp="3j2lo2x6yk4yw" />}
            </label>
          </li>)}
      </ul>
      {!disabled && <button onClick={() => onChange(items.map(() => true))} className="mt-2 text-xs font-medium text-navy-700 hover:underline" data-id="element-543" data-mp="3o0n5ldoqjw89">সব চিহ্নিত করুন</button>}
      <div className="mt-4 border-t border-slate-100 pt-3" data-id="element-544" data-mp="1m3v3s2vt172">
        <p className="mb-2 text-xs font-semibold text-slate-500" data-id="element-545" data-mp="5p0g1pfw99e6">যাচাইয়ের ফলাফল</p>
        <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="যাচাইয়ের ফলাফল" data-id="element-546" data-mp="5mw36i00p01r">
          {results.map(r => {
          const blocked = disabled || r.key === 'যাচাইকৃত' && !all;
          return <button key={r.key} role="radio" aria-checked={result === r.key} disabled={blocked} onClick={() => onResult(r.key)} title={r.key === 'যাচাইকৃত' && !all ? 'সকল বিষয় চিহ্নিত করার পর নির্বাচন করুন' : undefined} className={`rounded-md border px-2 py-2 text-[13px] font-semibold transition disabled:cursor-not-allowed disabled:opacity-40 ${result === r.key ? r.on : r.cls}`} data-id="element-547" data-mp="1q69o5dkdicy5">
                {r.key}
              </button>;
        })}
        </div>
      </div>
    </Panel>;
}